export const SDK_NAME = 'mito'
export const SDK_VERSION = '2.0.0'
export const SERVER_URL = '//localhost:3000/api/error/upload'
